/**
 * Messages module translations - Empty States section
 */

const emptyStates = {
  noMessages: "There are no messages yet",
  noMessagesDescription: "You will be informed when any appear",
  nothingFound: "Nothing found",
  nothingFoundDescription: "Try to change your filters",
};

export default emptyStates;
